
export default {

    languages: {
        italian: 'Italiano',
        english: 'English',
        french: 'Français',
        romanian: 'Română'
    }
};